import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    rallies: [],
    ralliesThemes: [],
    ralliesTargetGroups: [],
    selectedThemeId: null,
    selectedTargetGroupId: null,
    locationFilter: null,
    isTeamRally: undefined,
};
const ralliesPreviewSlice = createSlice({
    name: 'ralliesPreview',
    initialState,
    reducers: {
        setRallies: (state, action) => {
            state.rallies = action.payload;
        },
        setRalliesThemes: (state, action) => {
            state.ralliesThemes = action.payload;
        },
        setRalliesTargetGroups: (state, action) => {
            state.ralliesTargetGroups = action.payload;
        },
        setTheme: (state, action) => {
            state.selectedThemeId = action.payload;
        },
        setTargetGroup: (state, action) => {
            state.selectedTargetGroupId = action.payload;
        },
        setLocationFilter: (state, action) => {
            state.locationFilter = action.payload;
        },
        setIsTeamRally: (state, action) => {
            state.isTeamRally = action.payload;
        },
    },
    selectors: {
        selectRallies: (state) => state.rallies,
        selectRalliesThemes: (state) => state.ralliesThemes,
        selectRalliesTargetGroup: (state) => state.ralliesTargetGroups,
        getSelectThemeId: (state) => state.selectedThemeId,
        getSelectTargetGroupId: (state) => state.selectedTargetGroupId,
        getLocationFilter: (state) => state.locationFilter,
        getIsTeamRally: (state) => state.isTeamRally,
    },
});
export const { setRallies, setRalliesThemes, setRalliesTargetGroups, setTheme, setLocationFilter, setTargetGroup, setIsTeamRally, } = ralliesPreviewSlice.actions;
export const { selectRallies, selectRalliesThemes, selectRalliesTargetGroup, getSelectThemeId, getSelectTargetGroupId, getLocationFilter, getIsTeamRally, } = ralliesPreviewSlice.selectors;
export default ralliesPreviewSlice.reducer;
